import Image, { StaticImageData } from 'next/image';

export const TabImage: React.FC<{
  url: string | StaticImageData;
  alt: string;
}> = ({ url, alt }) => {
  return (
    <Image
      className="bg-black rounded-lg lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-10 3xl:translate-x-18 transition-transform duration-1000 ease-out shadow-xl xl:shadow-super lg:max-w-[50%] xl:max-w-none lg:mb-0 mb-9 select-none"
      src={url}
      alt={alt}
      width={649}
      height={402}
      quality={100}
      {...(typeof url !== 'string' && { placeholder: 'blur' })}
    />
  );
};
